export const STEP_LOADING = 'loading';
export const STEP_SELECT_WHISKEY = 'selectWhiskey';
export const STEP_SELECT_SPIRE = 'selectSpire';
export const STEP_SELECT_PROOF = 'selectProof';
export const STEP_SELECT_INFUSION = 'selectInfusion';
export const STEP_PERSONALIZE = 'personalize';
export const STEP_REVIEW = 'review';
